<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="over" class="mobile-menu">
    <mat-nav-list>
      @for (hoja of hojas; track hoja) {
        <a
          [routerLink]="urlSeccion(hoja)"
          mat-list-item
          (click)="sidenav.close()"
          >{{ hoja
          }}<i
            class="fa-solid fa-chevron-right"
            matListItemMeta
            aria-hidden="true"
          ></i
        ></a>
      }
      <a mat-list-item routerLink="cotizar" (click)="sidenav.close()"
        >Plan Canje<i
          class="fa-solid fa-chevron-right"
          matListItemMeta
          aria-hidden="true"
        ></i
      ></a>
      <a
        mat-list-item
        routerLink="preguntas-frecuentes"
        (click)="sidenav.close()"
        >Información<i
          class="fa-solid fa-chevron-right"
          matListItemMeta
          aria-hidden="true"
        ></i
      ></a>
      <a
        mat-list-item
        routerLink="reparacion-iphone-olavarria"
        (click)="sidenav.close()"
        >Servicio técnico<i
          class="fa-solid fa-chevron-right"
          matListItemMeta
          aria-hidden="true"
        ></i
      ></a>

      @if (dolarBlueFormateado) {
        <div class="dolar-item-mobile">
          <i class="fas fa-money-bill-wave" aria-hidden="true"></i>
          <span>Cotización USD: ${{ dolarBlueFormateado }}</span>
        </div>
      }

      <a
        mat-list-item
        class="whatsapp-cta-mobile"
        href="https://wa.me/5492284269400?text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20hacer%20una%20consulta%20sobre%20un%20iPhone."
        target="_blank"
        rel="noopener"
        (click)="sidenav.close()"
      >
        <i class="fab fa-whatsapp mr-2" aria-hidden="true"></i>
        <span>Consultar por WhatsApp</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    @if (!sinLayoutPublico) {
      <app-header
        [sidenav]="sidenav"
        [dolarBlueFormateado]="dolarBlueFormateado"
      ></app-header>
    }

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

    @if (!sinLayoutPublico) {
      <app-footer></app-footer>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
